import { gql, TypedDocumentNode } from '@apollo/client'
import {
  UserProfileAttributesFragment,
  USER_PROFILE_ATTRIBUTES_FRAGMENT,
} from 'graphql/fragments/users/userFragments'

type UserSearchInput = {
  page: number
  partnerIds?: number[]
  q: string
  size: number
}

type SearchUsersResponse = {
  searchUsers: {
    content: Array<{
      id: string
      accreditations: Array<{
        code: string
        description: string
      }>
      active: boolean
      companyName: string
      email: string
      firstName: string
      lastName: string
    }>
    pageInfo: {
      pageNumber: number
      pageSize: number
      totalPages: number
      totalElements: number
    }
  }
}

type SearchUsersAutocompleteData = {
  searchUsers: {
    content: Array<{
      id: string
      firstName: string
      lastName: string
      email: string
      lanId: string
      companyName: string
      internal: boolean
    }>
  }
}

type SearchUsersAutocompleteVars = { q: string }

export const SEARCH_USERS_AUTOCOMPLETE: TypedDocumentNode<
  SearchUsersAutocompleteData,
  SearchUsersAutocompleteVars
> = gql`
  query searchUsersTypeahead($q: String!) {
    searchUsers(page: 0, q: $q, size: 5) {
      content {
        id
        firstName
        lastName
        email
        lanId
        companyName
        internal
      }
    }
  }
`

export const USERS_SEARCH_QUERY: TypedDocumentNode<
  SearchUsersResponse,
  UserSearchInput
> = gql`
  query searchUsers($page: Int, $partnerIds: [Int!], $q: String!, $size: Int) {
    searchUsers(page: $page, partnerIds: $partnerIds, q: $q, size: $size) {
      content {
        id
        accreditations {
          code
          description
          status
        }
        active
        companyName
        email
        firstName
        lastName
      }
      pageInfo {
        pageNumber
        pageSize
        totalPages
        totalElements
      }
    }
  }
`

type GetRolesResponse = {
  roles: {
    content: Array<{ id: string; name: string }>
  }
}

export const GET_ROLES: TypedDocumentNode<
  GetRolesResponse,
  Record<string, never>
> = gql`
  query getRoles {
    roles(page: 0, size: 100) {
      content {
        id
        name
      }
    }
  }
`

type AccreditationType = {
  code: string
  description: string
  info: string[]
}

type GetUserByIdVars = {
  id: string
}

export type GetUserByIdResponse = {
  getById: UserProfileAttributesFragment
}

export const GET_USER_BY_ID: TypedDocumentNode<
  GetUserByIdResponse,
  GetUserByIdVars
> = gql`
  ${USER_PROFILE_ATTRIBUTES_FRAGMENT}
  query getById($id: ID!) {
    getById(id: $id) {
      ...UserProfileAttributes
    }
  }
`

type AccreditationTypesVars = {
  userType: string
}

type AccreditationTypesResponse = {
  getAccreditationTypes: AccreditationType[]
}

export const GET_ACCREDITATION_TYPES: TypedDocumentNode<
  AccreditationTypesResponse,
  AccreditationTypesVars
> = gql`
  query getAccreditationTypes($userType: String!) {
    getAccreditationTypes(userType: $userType) {
      code
      description
      info
    }
  }
`
